/* ==========================================================================
   E&H Design · Ratgeber
   assets/ehdesign-ratgeber.js
   Version 3.2

   TUT GENAU ZWEI DINGE, beides nur innerhalb von .ehdesign-article-page:
     1. Tabellen fuer kleine Bildschirme vorbereiten
     2. einen echten FAQ-Abschnitt in ein Akkordeon verwandeln

   SICHERHEIT
     Gibt es kein .ehdesign-article-page auf der Seite, passiert nichts.
     Es werden ausschliesslich vorhandene DOM-Knoten VERSCHOBEN, niemals
     innerHTML neu geschrieben. Listen, Links, Bilder, Tabellen und
     Formatierungen in den Antworten bleiben unveraendert erhalten.
     Das Server-HTML bleibt unangetastet: ohne JavaScript ist der Abschnitt
     weiterhin als H2 mit H3-Fragen vollstaendig lesbar und indexierbar.

   NEU IN 3.0
     · Ein FAQ-Abschnitt wird an seiner STRUKTUR erkannt, nicht mehr am
       Wortlaut der Ueberschrift. Vorher gab es eine Liste erlaubter Titel,
       gegen die exakt verglichen wurde; "Haeufige Fragen zur Miete eines
       Wasserspenders" und "FAQ zur Lagerung von Bierfaessern" fielen beide
       durch. Jetzt zaehlt, ob die Unterpunkte Fragen sind. Kuenftige
       Beitraege brauchen dadurch keine Codepflege mehr.
     · Alle passenden Abschnitte werden umgebaut, nicht nur der erste.
     · Die Gruppe haelt hoechstens eine offene Frage. Beim Oeffnen einer
       zweiten faehrt die vorherige animiert zu.
     · Eine Kopfzeile ohne thead wird zu einer echten Kopfzeile gemacht.
       Zwei der fuenf Beitraege liefern ihre Tabelle als <table><tr><th>…
       ohne thead-Element. Der Browser steckt dann ALLE Zeilen in einen
       stillschweigend ergaenzten tbody, table.tHead bleibt leer. Folge:
       der dunkle Kopfbalken fehlte am Schreibtisch, und auf dem Telefon
       gab es keine Kartenansicht, weil die Spaltennamen nicht auffindbar
       waren. Beides ist mit dieser einen Umstellung erledigt.
     · Tabellen werden auf dem Telefon nicht mehr seitlich geschoben,
       sondern Zeile fuer Zeile als Karte gezeigt. Dafuer bekommt jede
       Zelle die Beschriftung ihrer Spalte mit, weil der Tabellenkopf in
       dieser Ansicht nicht mehr sichtbar ist. Tabellen, deren Aufbau das
       nicht hergibt, bleiben beim bisherigen Schieben.
     · Die Frage bleibt eine echte H3. Vorher wurde ihr Text in ein span
       umgefuellt und die Ueberschrift verworfen — pro Beitrag verschwanden
       so drei bis vier H3 aus der Gliederung.

   NEU IN 2.0
     · Das Schliessen bricht sauber ab. Vorher blieb ein Timer stehen, der
       eine gerade wieder geoeffnete Frage erneut geschlossen hat. Bei drei
       schnellen Klicks blieb die Frage mit [open] UND der Schliess-Markierung
       stehen, und die CSS-Regel hat das Panel auf null Hoehe fixiert: eine
       offene, aber leere Box. Jetzt wird jeder laufende Vorgang beim naechsten
       Klick abgebrochen, und ein abgelaufener Rueckruf kann nichts mehr
       schliessen. Ein Klick waehrend des Schliessens oeffnet wieder.
     · Das Akkordeon wird an der Stelle der ERSTEN Frage eingefuegt, nicht
       direkt unter der Ueberschrift. Ein Einleitungssatz zwischen H2 und
       erster Frage bleibt dadurch oben stehen statt unter dem Akkordeon.
     · Eine ID an der Frage wandert auf das details-Element, damit
       Sprungmarken wie #frage-1 weiter funktionieren. Zeigt die Adresse
       beim Laden auf eine Frage, wird sie geoeffnet.
     · Ein <hr> beendet den FAQ-Bereich wie eine neue H2. Vorher wurde alles
       bis zur naechsten H2 in die letzte Antwort gezogen.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.ehdesign-article-page';

  /* Wie viele Frage-Antwort-Paare ein Abschnitt mindestens haben muss,
     damit daraus ein Akkordeon wird. Ein einzelnes Paar ist keines. */
  var MIN_ITEMS = 2;

  /* Inhaltsverzeichnis: Ueberschrift und Mindestzahl an Abschnitten.
     Unter drei Abschnitten lohnt sich die Uebersicht nicht, sie waere
     nur ein zweiter Kasten ueber demselben Text. */
  var TOC_TITLE = 'In diesem Beitrag';
  var MIN_TOC = 3;

  /* Notbremse, falls transitionend nicht feuert, etwa weil das Panel
     ausgeblendet ist. Muss laenger sein als die CSS-Transition. */
  var CLOSE_FALLBACK_MS = 450;

  var ICON =
    '<svg class="ehdesign-faq__icon" viewBox="0 0 16 16" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path d="M8 3v10M3 8h10" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* Umlaute und Satzzeichen vereinheitlichen, damit
     "Häufig gestellte Fragen:" genauso trifft wie "HAEUFIGE FRAGEN". */
  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 'ss')
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isTag(node, name) {
    return node && node.nodeType === 1 && node.tagName.toLowerCase() === name;
  }

  function isBlank(node) {
    return node.nodeType === 3 && !String(node.nodeValue).trim();
  }

  /* ---------------------------------------------------------------- Tabellen */
  function wrapTables(root) {
    var tables = root.querySelectorAll('.ehdesign-article__content table');
    for (var i = 0; i < tables.length; i++) {
      var table = tables[i];
      var parent = table.parentNode;
      if (!parent) continue;
      if (parent.classList && parent.classList.contains('ehdesign-table-wrap')) continue;

      var wrap = document.createElement('div');
      wrap.className = 'ehdesign-table-wrap';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', 'Tabelle, horizontal scrollbar');
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    }

    /* Danach Kopfzeile geradeziehen und beschriften, auch fuer die
       bereits im Snippet umschlossenen Tabellen. */
    for (var t = 0; t < tables.length; t++) {
      normalizeHead(tables[t]);
      labelCells(tables[t]);
    }
  }

  /* Macht aus einer Kopfzeile ohne thead eine echte Kopfzeile.

     Kommt die Tabelle als <table><tr><th>…</th></tr><tr><td>… an, ergaenzt
     der Browser still einen tbody um ALLE Zeilen. table.tHead ist dann leer,
     obwohl die erste Zeile offensichtlich der Kopf ist. Dadurch griff weder
     die Regel fuer den dunklen Kopfbalken noch die Kartenansicht.

     Erkannt wird das daran, dass die erste Zeile AUSSCHLIESSLICH aus
     th-Zellen besteht. Eine Tabelle mit Zeilenkoepfen links, also th gefolgt
     von td in derselben Zeile, faellt damit bewusst nicht darunter und
     bleibt unberuehrt.

     Es wird nur eine vorhandene Zeile verschoben, nichts neu geschrieben. */
  function normalizeHead(table) {
    if (table.tHead) return;

    var bodies = table.tBodies;
    if (!bodies.length || !bodies[0].rows.length) return;

    var first = bodies[0].rows[0];
    if (!first.cells.length) return;
    for (var i = 0; i < first.cells.length; i++) {
      if (first.cells[i].tagName.toLowerCase() !== 'th') return;
    }

    var head = document.createElement('thead');
    table.insertBefore(head, bodies[0]);
    head.appendChild(first);
  }

  /* Bereitet eine Tabelle fuer die Kartenansicht auf kleinen Bildschirmen vor.

     Dort ist der Tabellenkopf ausgeblendet, sonst waere jede Zelle ein Wert
     ohne Bezeichnung. Deshalb bekommt jede Zelle den Text ihrer Spalte als
     Attribut mit, das die CSS-Regel davorsetzt.

     Das geht nur bei regelmaessigen Tabellen. Sobald Zellen zusammengefasst
     sind oder eine Zeile anders viele Zellen hat als der Kopf, stimmt die
     Zuordnung Spalte zu Zelle nicht mehr — dann wird nichts markiert und es
     bleibt beim seitlichen Schieben. Eine falsche Beschriftung waere
     schlimmer als gar keine. */
  function labelCells(table) {
    var head = table.tHead;
    if (!head || !head.rows.length) return;

    /* Bei mehrzeiligem Kopf zaehlt die unterste Zeile: dort stehen die
       Spalten, zu denen die Zellen darunter gehoeren. */
    var headRow = head.rows[head.rows.length - 1];
    var labels = [];
    for (var i = 0; i < headRow.cells.length; i++) {
      var cell = headRow.cells[i];
      if (cell.colSpan > 1 || cell.rowSpan > 1) return;
      labels.push(String(cell.textContent || '').replace(/\s+/g, ' ').trim());
    }
    if (!labels.length) return;

    var bodies = table.tBodies;
    var rows = [];
    for (var b = 0; b < bodies.length; b++) {
      for (var r = 0; r < bodies[b].rows.length; r++) {
        var row = bodies[b].rows[r];
        if (row.cells.length !== labels.length) return;
        for (var c = 0; c < row.cells.length; c++) {
          if (row.cells[c].colSpan > 1 || row.cells[c].rowSpan > 1) return;
        }
        rows.push(row);
      }
    }
    if (!rows.length) return;

    for (var k = 0; k < rows.length; k++) {
      var cells = rows[k].cells;
      for (var m = 0; m < cells.length; m++) {
        if (labels[m]) cells[m].setAttribute('data-ehdesign-label', labels[m]);
      }
    }

    table.setAttribute('data-ehdesign-stack', '');

    /* Der Rahmen darf in dieser Ansicht nicht mehr schieben. */
    var wrap = table.parentNode;
    if (wrap && wrap.classList && wrap.classList.contains('ehdesign-table-wrap')) {
      wrap.classList.add('ehdesign-table-wrap--stacked');
    }
  }

  /* ------------------------------------------------ INHALTSVERZEICHNIS */

  /* Aus der Ueberschrift eine brauchbare Sprungmarke machen. Umlaute
     werden ausgeschrieben, alles andere auf Kleinbuchstaben und
     Bindestriche reduziert. */
  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  /* Baut die Uebersicht aus den H2 des Beitragstextes und haengt sie vor
     den ersten CTA, also zwischen Einleitung und Artikel.

     Es werden ausschliesslich vorhandene Ueberschriften gelesen; am Text
     selbst aendert sich nichts ausser einer id, falls noch keine da ist.
     Ohne JavaScript fehlt die Uebersicht, der Beitrag bleibt vollstaendig. */
  function buildToc(root) {
    if (root.querySelector('.ehdesign-toc')) return;

    /* Nur Beitraege, keine Kategorieseiten. Der Textblock einer Kategorie
       traegt dieselbe Wurzel .ehdesign-article-page, damit er die
       Artikeltypografie erbt — eine Uebersicht ist dort aber nicht
       gewuenscht: der Text steht ohnehin schon unter dem Produktraster. */
    if (root.classList && root.classList.contains('ehdesign-collection-page')) return;

    var containers = root.querySelectorAll('[data-ehdesign-faq]');
    var heads = [];
    var i, j;
    for (i = 0; i < containers.length; i++) {
      var found = containers[i].querySelectorAll('h2');
      for (j = 0; j < found.length; j++) heads.push(found[j]);
    }
    if (heads.length < MIN_TOC) return;

    var list = document.createElement('ol');
    list.className = 'ehdesign-toc__list';

    for (i = 0; i < heads.length; i++) {
      var heading = heads[i];
      var label = String(heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label) continue;

      var id = heading.id;
      if (!id) {
        var base = slugify(label) || 'abschnitt';
        id = base;
        var n = 2;
        while (document.getElementById(id)) {
          id = base + '-' + n;
          n++;
        }
        heading.id = id;
      }

      var item = document.createElement('li');
      item.className = 'ehdesign-toc__item';
      var link = document.createElement('a');
      link.className = 'ehdesign-toc__link';
      link.setAttribute('href', '#' + id);
      link.textContent = label;
      item.appendChild(link);
      list.appendChild(item);
    }

    if (!list.children.length) return;

    var nav = document.createElement('nav');
    nav.className = 'ehdesign-toc';
    var titleId = 'ehdesign-toc-title';
    while (document.getElementById(titleId)) titleId += '-x';
    nav.setAttribute('aria-labelledby', titleId);

    var title = document.createElement('p');
    title.className = 'ehdesign-toc__title';
    title.id = titleId;
    title.textContent = TOC_TITLE;

    nav.appendChild(title);
    nav.appendChild(list);

    /* WOHIN DAS VERZEICHNIS KOMMT

       Es gehoert an den Anfang des Beitrags, nie mitten hinein.

       Gibt es eine Einleitung, steht es direkt DAHINTER — der Beitrag
       beginnt dann mit dem Einleitungsabsatz, danach die Uebersicht,
       danach CTA 1 und der Artikel.

       Gibt es keine Einleitung (sechs der zehn Beitraege starten sofort
       mit einer Ueberschrift), steht es GANZ OBEN vor dem ersten
       Inhaltsblock.

       Frueher war der Anker '.ehdesign-cta' — irgendein CTA. Fehlte CTA 1,
       traf das CTA 2, und das sitzt vor der LETZTEN Ueberschrift: die
       Uebersicht landete dadurch am Ende des Beitrags. Deshalb wird jetzt
       ausschliesslich an den Inhaltsbloecken ausgerichtet, nicht an den
       CTA-Bloecken. */
    var intro = root.querySelector('.ehdesign-article__content--intro');
    var anchor = null;
    var before = true;

    if (intro && intro.parentNode) {
      anchor = intro;
      before = false;
    } else if (containers.length) {
      anchor = containers[0];
    }

    if (!anchor || !anchor.parentNode) return;
    if (before) {
      anchor.parentNode.insertBefore(nav, anchor);
    } else {
      anchor.parentNode.insertBefore(nav, anchor.nextSibling);
    }

    wireToc(list);
  }

  /* Ein Klick scrollt weich zur Ueberschrift statt hart zu springen.
     Wer Bewegung reduziert haben moechte, bekommt den harten Sprung.
     Die Adresse wird mitgefuehrt, damit der Link teilbar bleibt. */
  function wireToc(list) {
    list.addEventListener('click', function (event) {
      var link = event.target;
      while (link && link !== list && !(link.classList && link.classList.contains('ehdesign-toc__link'))) {
        link = link.parentNode;
      }
      if (!link || link === list) return;

      var id = String(link.getAttribute('href') || '').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });

      /* Die Ueberschrift bekommt den Fokus, sonst liest ein Screenreader
         nach dem Sprung weiter an der alten Stelle. preventScroll, damit
         der Fokus die weiche Bewegung nicht ueberholt. */
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (e) { /* aelterer Browser */ }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });
  }

  /* --------------------------------------------------------------------- FAQ */

  /* Erkennt eine Frage an ihrem Fragezeichen. Das ist das einzige Merkmal,
     das unabhaengig von der Formulierung und von der Sprache funktioniert. */
  function isQuestion(node) {
    return /[?\uFF1F]\s*$/.test(String(node.textContent || '').trim());
  }

  /* Zweitsignal: die Ueberschrift nennt sich selbst FAQ oder Fragen.
     Greift nur zusaetzlich, nie allein — ohne Fragen gibt es kein Akkordeon. */
  function headingNamesFaq(heading) {
    var n = normalize(heading.textContent);
    return /(^|\s)faqs?(\s|$)/.test(n) || /(^|\s)fragen(\s|$)/.test(n);
  }

  /* Sammelt alles zwischen dieser H2 und der naechsten H2 oder einem <hr>. */
  function collectRange(start) {
    var range = [];
    var node = start.nextSibling;
    while (node && !isTag(node, 'h2') && !isTag(node, 'hr')) {
      range.push(node);
      node = node.nextSibling;
    }
    return range;
  }

  /* Zerlegt den Bereich in Frage-Antwort-Paare.
     Alles VOR der ersten H3 bleibt unangetastet stehen (Einleitungstext). */
  function splitItems(range) {
    var items = [];
    var current = null;
    for (var j = 0; j < range.length; j++) {
      var n = range[j];
      if (isTag(n, 'h3')) {
        if (n.closest && n.closest('details')) return null;
        current = { question: n, body: [] };
        items.push(current);
      } else if (current && !isBlank(n)) {
        current.body.push(n);
      }
    }
    return items;
  }

  /* Die eigentliche Entscheidung.

     Frueher stand hier eine Liste erlaubter Ueberschriften, gegen die exakt
     verglichen wurde. Damit fiel jede Ueberschrift durch, die auch nur ein
     Wort mehr enthielt — "Haeufige Fragen zur Miete eines Wasserspenders"
     oder "FAQ zur Lagerung von Bierfaessern" wurden nicht erkannt, obwohl
     beides eindeutig FAQ-Abschnitte sind. Fuer jeden neuen Beitrag haette
     jemand die Liste pflegen muessen.

     Jetzt entscheidet die STRUKTUR, nicht der Wortlaut:
       · mindestens MIN_ITEMS Unterpunkte, und
       · die Mehrheit davon endet mit einem Fragezeichen
     ODER die Ueberschrift nennt sich selbst FAQ beziehungsweise Fragen und
     es gibt mindestens MIN_ITEMS Unterpunkte.

     Dadurch funktioniert jede kuenftige Formulierung ohne Codeaenderung,
     und ein normaler Abschnitt mit Zwischenueberschriften bleibt ein
     normaler Abschnitt. */
  function qualifies(heading, items) {
    if (!items || items.length < MIN_ITEMS) return false;

    var questions = 0;
    for (var i = 0; i < items.length; i++) {
      if (isQuestion(items[i].question)) questions++;
    }
    if (questions >= MIN_ITEMS && questions * 2 >= items.length) return true;

    return headingNamesFaq(heading);
  }

  function buildFaq(container) {
    if (container.getAttribute('data-ehdesign-faq-done') === '1') return;
    container.setAttribute('data-ehdesign-faq-done', '1');

    /* ALLE Ueberschriften pruefen, nicht nur die erste passende: ein
       Beitrag darf mehr als einen Frageblock enthalten. querySelectorAll
       liefert eine statische Liste, spaetere Umbauten stoeren sie nicht.
       Die Bereiche sind disjunkt, deshalb ist die Reihenfolge unkritisch. */
    var headings = container.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      if (heading.closest && heading.closest('details')) continue;

      var items = splitItems(collectRange(heading));
      if (!qualifies(heading, items)) continue;

      buildGroup(items);
    }
  }

  /* Baut aus den Paaren ein Akkordeon und haengt es an die Stelle der
     ersten Frage, damit ein Einleitungssatz oben stehen bleibt. */
  function buildGroup(items) {
    var anchor = items[0].question;
    if (!anchor.parentNode) return;

    var wrap = document.createElement('div');
    wrap.className = 'ehdesign-faq';
    anchor.parentNode.insertBefore(wrap, anchor);

    var group = [];

    for (var k = 0; k < items.length; k++) {
      var item = items[k];

      var details = document.createElement('details');
      details.className = 'ehdesign-faq__item';
      if (item.question.id) details.id = item.question.id;

      var summary = document.createElement('summary');
      summary.className = 'ehdesign-faq__summary';

      /* Die H3 selbst wandert in das summary, statt ihren Text in ein span
         umzufuellen. summary darf laut HTML genau ein Ueberschriftenelement
         enthalten, und die Frage bleibt dadurch eine echte Ueberschrift:
         sie steht weiter in der Dokumentgliederung, Screenreader koennen sie
         anspringen und Suchmaschinen sehen sie. Vorher gingen pro Beitrag
         drei bis vier H3 verloren. */
      var question = item.question;
      question.className = question.className
        ? question.className + ' ehdesign-faq__question'
        : 'ehdesign-faq__question';
      /* Die ID sitzt jetzt am details, sonst gaebe es sie zweimal. */
      question.removeAttribute('id');
      summary.appendChild(question);
      summary.insertAdjacentHTML('beforeend', ICON);
      details.appendChild(summary);

      var panel = document.createElement('div');
      panel.className = 'ehdesign-faq__panel';
      var inner = document.createElement('div');
      inner.className = 'ehdesign-faq__panel-inner';
      var body = document.createElement('div');
      body.className = 'ehdesign-faq__body';

      for (var m = 0; m < item.body.length; m++) {
        body.appendChild(item.body[m]);
      }

      inner.appendChild(body);
      panel.appendChild(inner);
      details.appendChild(panel);
      wrap.appendChild(details);

      group.push({ details: details, panel: panel, timer: null, pending: null });
    }

    /* Kein Aufraeumen noetig: appendChild hat die H3 bereits aus dem
       Artikeltext in das summary verschoben, eine leere Huelle bleibt nicht
       zurueck. Ein Entfernen an dieser Stelle wuerde die Frage loeschen. */

    wireGroup(group);
    openFromHash(group);
  }

  /* --------------------------------------------------------- Akkordeonlogik */

  /* Eine Gruppe haelt immer hoechstens EINE offene Frage. Wird eine zweite
     geoeffnet, faehrt die vorherige animiert zu, statt hart zu verschwinden.

     Oeffnen animiert der Browser ueber die CSS-Transition von selbst.
     Schliessen wuerde nativ hart springen, deshalb laeuft es hier ueber die
     Markierung data-ehdesign-closing und wird danach erst wirklich geschlossen. */
  function wireGroup(group) {
    function cleanup(it) {
      if (it.timer) {
        window.clearTimeout(it.timer);
        it.timer = null;
      }
      if (it.pending) {
        it.panel.removeEventListener('transitionend', it.pending);
        it.pending = null;
      }
    }

    function closeItem(it) {
      if (!it.details.open) return;

      if (prefersReducedMotion()) {
        cleanup(it);
        it.details.removeAttribute('data-ehdesign-closing');
        it.details.open = false;
        return;
      }

      cleanup(it);
      it.details.setAttribute('data-ehdesign-closing', '');

      var finish = function () {
        /* Ein abgelaufener Rueckruf darf nichts mehr schliessen. */
        if (!it.details.hasAttribute('data-ehdesign-closing')) return;
        cleanup(it);
        it.details.removeAttribute('data-ehdesign-closing');
        it.details.open = false;
      };

      it.pending = finish;
      it.panel.addEventListener('transitionend', finish);
      it.timer = window.setTimeout(finish, CLOSE_FALLBACK_MS);
    }

    function closeOthers(except) {
      for (var i = 0; i < group.length; i++) {
        if (group[i] !== except) closeItem(group[i]);
      }
    }

    for (var i = 0; i < group.length; i++) {
      (function (it) {
        var summary = it.details.querySelector('.ehdesign-faq__summary');
        if (!summary) return;

        summary.addEventListener('click', function (event) {
          /* Mitten im Schliessen geklickt: abbrechen und offen lassen. */
          if (it.details.hasAttribute('data-ehdesign-closing')) {
            event.preventDefault();
            cleanup(it);
            it.details.removeAttribute('data-ehdesign-closing');
            closeOthers(it);
            return;
          }

          /* Geschlossen: der Browser oeffnet, CSS animiert.
             Vorher faehrt eine eventuell offene Schwester zu. */
          if (!it.details.open) {
            cleanup(it);
            closeOthers(it);
            return;
          }

          /* Offen: animiert schliessen statt hart zuzuklappen. */
          if (prefersReducedMotion()) {
            cleanup(it);
            return;
          }
          event.preventDefault();
          closeItem(it);
        });
      })(group[i]);
    }

    /* Damit auch openFromHash die Schwestern schliessen kann. */
    group.closeOthers = closeOthers;
  }

  /* Zeigt die Adresse auf eine Frage, wird sie geoeffnet. */
  function openFromHash(group) {
    var hash = window.location && window.location.hash;
    if (!hash || hash.length < 2) return;
    var id = hash.slice(1);

    for (var i = 0; i < group.length; i++) {
      if (group[i].details.id !== id) continue;
      if (group.closeOthers) group.closeOthers(group[i]);
      group[i].details.open = true;
      if (group[i].details.scrollIntoView) {
        group[i].details.scrollIntoView({ block: 'start' });
      }
      return;
    }
  }

  /* --------------------------------------------------------------------- Init */
  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) return;

    for (var i = 0; i < roots.length; i++) {
      wrapTables(roots[i]);
      buildToc(roots[i]);
      var containers = roots[i].querySelectorAll('[data-ehdesign-faq]');
      for (var j = 0; j < containers.length; j++) {
        buildFaq(containers[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Der Theme-Editor rendert Sektionen neu. Dann erneut initialisieren,
     ohne bereits verarbeitete Container ein zweites Mal anzufassen. */
  document.addEventListener('shopify:section:load', init);
})();
